import { Box, Stack, Typography } from "@mui/material";
import JoinUs from "./JoinUsButton";

export default function Convinient({conviData,prof}){
    return(
      <Box component="section" sx={{ my: { xs: 5, md: 8 }, textAlign: "center" }}>
        <Typography
          component="h2"
          sx={{
            mb: 3.5,
            fontFamily: "Assistant",
            fontWeight: 800,
            fontSize: { xs: "1.75rem", md: "2.3rem" },
            color: "#173c5d",
          }}
        >
          שכנעתם, אני רוצה להצטרף! מה עושים?
        </Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2.5}>
          {conviData.map(e=>{
            return(
              <Box
                key={e.text}
                sx={{
                  flex: 1,
                  p: 2.5,
                  borderRadius: "20px",
                  bgcolor: "#fff",
                  border: "1px solid #e2ebf2",
                  boxShadow: "0 10px 28px rgba(22, 67, 103, .07)",
                }}
              >
                <Box
                  sx={{
                    width: { xs: 118, sm: 128, md: 138 },
                    height: { xs: 118, sm: 128, md: 138 },
                    mx: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "28px",
                    background: "linear-gradient(145deg, #f5fbff 0%, #edf6fc 100%)",
                    border: "1px solid #dbeaf5",
                    boxShadow: "0 10px 24px rgba(31, 104, 158, .10)",
                  }}
                >
                  <Box
                    component="img"
                    src={e.image}
                    alt={e.text}
                    sx={{
                      display: "block",
                      width: { xs: 88, sm: 96, md: 104 },
                      height: { xs: 88, sm: 96, md: 104 },
                      objectFit: "contain",
                    }}
                  />
                </Box>
                <Typography
                  component="p"
                  sx={{
                    mt: 2,
                    mb: 0,
                    textAlign: "center",
                    fontSize: { xs: "1rem", md: "1.08rem" },
                    lineHeight: 1.55,
                    fontFamily: "Assistant",
                    fontWeight: 700,
                    color: "#355a75",
                  }}
                >
                  {e.text}
                </Typography>
              </Box>
            );
          })}
        </Stack>
        <Box sx={{ mt: 4 }}>
          <JoinUs prof={prof} text={"התחל הרשמה"}/>
        </Box>
      </Box>
    );
}
